export const audienceTypes = [{ id: "SELLER", name: "Vendedor" }];
